import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function updateWishlist(wishlistId, accessSpecifier, descriptionName, wishlistConfigs) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret } = wishlistConfigs;

    invariant(baseUrl, 'baseUrl is a required param of updateWishlist()');
    invariant(brandId, 'brandId is a required param of updateWishlist()');
    invariant(country, 'country is a required param of updateWishlist()');
    invariant(wishlistId, 'wishlistId is a required param of updateWishlist()');
    invariant(uberToken, 'uberToken is a required param of updateWishlist()');
    invariant(clientId, 'clientId is a required param of updateWishlist()');
    invariant(descriptionName || accessSpecifier, 'description name or access specifier are a required param of updateWishlist()');

    const updateURL = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wishlist/${wishlistId}`;

    const headers = { 'Content-Type': 'application/json' };

    const body = JSON.stringify({
        descriptionName: descriptionName,
        accessSpecifier: accessSpecifier,
    });

    return labelRequest(
        authenticatedRequest(new Request(updateURL, { headers: new Headers(headers), method: 'PUT', body }), uberToken, clientId, clientSecret),
        'updateWishlist',
    );
}
